import axios from 'axios';
import config from '@/config';
import { WORK_TYPE_OPTIONS } from '@/features/gnmk/constants/workTypeEnums.js';
const base = config.ctx.iffApi;
export const dailyTaskService = {
  page: params => axios.get(base + '/daily-task/page', { params }),
  detail: id => axios.get(base + '/daily-task/detail/' + id),
  save: data => axios.post(base + '/daily-task/save', data),
  complete: data => axios.post(base + '/daily-task/complete', data),
  delete: (id, version) => axios.delete(base + '/daily-task/delete/' + id, { params: { version } }),
  devices: params => axios.get(base + '/device/page', { params })
};
export function unwrap (response) {
  const data = response.data;
  return data && data.data !== undefined ? data.data : data;
}
export const workTypes = WORK_TYPE_OPTIONS;
